import { HALF_MAX_PAGES, MAX_PAGES } from '../constants';

export const getPaginationRange = ({ totalPages, currentPage }) => {
    const maxPagesBeforeCurrentPage = HALF_MAX_PAGES;
    const maxPagesAfterCurrentPage = HALF_MAX_PAGES - 1;

    // Less than 10 pages
    if (totalPages <= MAX_PAGES) {
        return {
            startPage: 1,
            endPage: totalPages,
        };
    }

    // The current page is in the range 1-10
    if (currentPage <= maxPagesBeforeCurrentPage) {
        return {
            startPage: 1,
            endPage: MAX_PAGES,
        };
    }

    // End of the pagination
    if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
        return {
            startPage: totalPages - MAX_PAGES + 1,
            endPage: totalPages,
        };
    }

    // Middle of the pagination
    return {
        startPage: currentPage - maxPagesBeforeCurrentPage,
        endPage: currentPage + maxPagesAfterCurrentPage,
    };
};

export const isCurrentPage = (page, currentPage) => page === currentPage;
